import { memoize } from 'lodash-es';

export default memoize((email) => {
  return /\S+@\S+\.\S+/.test(email);
});
